import { AnyExtension } from '@tiptap/core';
import { BulletList } from '@tiptap/extension-bullet-list';
import { BlockNodes, ListNodes } from '../../available-extensions';

export function createBulletedListExtension(): AnyExtension {
  return BulletList.extend({
    name: BlockNodes.BulletedList,
  }).configure({ itemTypeName: ListNodes.ListItem });
}
